<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><a id="start"><i>to my cousin</i></a></p><a id="start">
<p class="center"><i>Glenn Morrow,</i></p>
<p class="center"><i>the brother I never had</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5dedication.vue?8d9bae7a